import React from 'react'
import { Box, ListSubheader, Stack, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { UserRpps } from '@saas/interfaces/core'
import styles from '../_styles/searchRppsStyles'
import { SearchRppsOptionProps } from './_props'

const getCivilStatus = (option: UserRpps) => {
    const { codecivilite, codecivilitedexercice } = option
    if (codecivilitedexercice) {
        return (
            <span>
                {codecivilitedexercice[0]}
                <sup>{codecivilitedexercice.slice(1).toLowerCase()}</sup>
            </span>
        )
    }
    if (codecivilite) {
        return (
            <span>
                {codecivilite[0]}
                {codecivilite === 'M' ? '.' : <sup>{codecivilite.slice(1).toLowerCase()}</sup>}
            </span>
        )
    }
    return null
}

const getAdditionalInfo = (option: UserRpps) => {
    const { libellesavoirfaire, libelleprofession, libellecommunecoordstructure } = option

    const infos = []
    if (libelleprofession) {
        infos.push(libelleprofession)
    }
    if (libellesavoirfaire) {
        infos.push(libellesavoirfaire)
    }
    if (libellecommunecoordstructure) {
        infos.push(libellecommunecoordstructure.toUpperCase())
    }
    return infos.join(' - ')
}

const useStyles = makeStyles(styles)

const SearchRppsOption: React.FC<SearchRppsOptionProps> = ({
    nbDisplayedOptions,
    nbFoundOptions,
    hasSubheader,
    option,
    optionProps,
    inputValue,
}) => {
    const { lastName, firstName, identifiantpp } = option
    const classes = useStyles()

    return (
        <Box className={classes.option}>
            {hasSubheader && (
                <Box>
                    <ListSubheader
                        className={classes.optionSubHeader}
                    >{`${nbDisplayedOptions} affichés / ${nbFoundOptions} résultats pour "${inputValue}"`}</ListSubheader>
                </Box>
            )}
            <Box component="li" {...optionProps}>
                <Stack>
                    <Typography className={classes.optionMainInfo}>
                        {getCivilStatus(option)}
                        {` ${lastName} ${firstName} (${identifiantpp})`}
                    </Typography>
                    <Typography className={classes.optionAdditionalInfo}>{getAdditionalInfo(option)}</Typography>
                </Stack>
            </Box>
        </Box>
    )
}

export default SearchRppsOption
